import {useState} from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EnergySlider from '../components/EnergySlider/EnergySlider';
import '../assets/css/styles.css';
import Parser from "html-react-parser";
import { changeDimLevel, revertDimLevel } from '../../../Helpers/fetchDevices';


const DeviceModal = ({ marker, onClose }) => {
  const [energyValue, setEnergyValue] = useState(100);
  if (!marker) return null;

  const handleSliderChange = (event, newValue) => {
    setEnergyValue(newValue);
  };

  return (
    <Modal open={!!marker} onClose={onClose}>
      <Box className="modal">
        <div className="modal-content">
          <Typography variant="h4" gutterBottom>Στοιχεία Θέσης</Typography>
          <Typography variant="h6">{marker.deviceName}</Typography>

          {marker.metrics && marker.metrics[0].slice(2).map((metric, idx) => (
              <Box key={idx} sx={{ my: 1 }}>
                {Parser(metric)}
              </Box>
            ))}

          <Typography variant="subtitle1" gutterBottom>Επίπεδο Φωτισμού {energyValue}</Typography>
          <EnergySlider value={energyValue} onChange={handleSliderChange}></EnergySlider>

          <Box sx={{ my: 2 }}>
            <Button variant="contained" fullWidth sx={{ mb: 1 }} onClick={() => changeDimLevel(marker.deviceName, energyValue, "autonomus")}>
              Αποστολή στη Συσκευή
            </Button>
            <Typography variant="body2" gutterBottom>
              Εάν αποστείλατε εντολή, επιλέξτε την επαναφορά στα προγράμματα σε περίπτωση που έχετε ενεργοποιήσει κάποιο πρόγραμμα για τη συσκευή αυτή.
            </Typography>
            <Button variant="contained" fullWidth onClick={() => revertDimLevel(marker.deviceName, "autonomus")}>
              Επαναφορά στα Προγράμματα
            </Button>
          </Box>

        </div>
      </Box>
    </Modal>
  );
};

export default DeviceModal;
